import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { history } from './history';
import DetailKum from './Admin/DetailKum';
import BuatKum from './Admin/BuatKum';
import EditKum from './Admin/EditKum';
import PengajuanKUM from './Mahasiswa/PengajuanKuliahUmum/CreatePengajuan';
import Home from './Home';
import TambahAdmin from './Superadmin/TambahAdmin';
import ProtectedRoute from './ProtectedRoute';
import HistoriKum from './Admin/HistoriKum';
import DaftarProgres from './Mahasiswa/PengajuanKuliahUmum/DaftarProgres';
import DetailProgres from './Mahasiswa/PengajuanKuliahUmum/DetailProgres';
import Unknown from './Unknown';
import BuatKlaimKum from './Mahasiswa/BuatKlaimKum';
import DaftarApproval from './Admin/DaftarPengajuanKum/DaftarApproval';
import DetailApproval from './Admin/DaftarPengajuanKum/DetailApproval';
import DaftarApprovalPartisipasi from './Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi';
import DetailApprovalPartisipasi from './Admin/DaftarPengajuanPartisipasi/DetailApprovalPartisipasi';
import HistoriPengajuanPartisipasi from './Mahasiswa/HistoriPengajuanPartisipasi';
import DetailPengajuanPartisipasi from './Mahasiswa/DetailPengajuanPartisipasi';
import PemeriksaanMahasiswa from './Admin/PemeriksaanMahasiswa';

const Routes = () => (
  <Router history={history}>
    <Switch>
      <ProtectedRoute exact path="/Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi" component={DaftarApprovalPartisipasi} admin />
      <ProtectedRoute exact path="/Admin/DaftarPengajuanPartisipasi/detail/:idMahasiswa" component={DetailApprovalPartisipasi} admin />
      <ProtectedRoute exact path="/Admin/" component={DaftarApproval} admin />
      <ProtectedRoute exact path="/Admin/PengajuanKuliahUmum/DaftarPengajuan" component={DaftarApproval} admin />
      <ProtectedRoute exact path="/Admin/PengajuanKuliahUmum/detail/:idProgres" component={DetailApproval} admin />
      <Route exact path="/DetailKum/:idKum" component={DetailKum} />
      <Route exact path="/" component={Home} />
      <ProtectedRoute exact path="/Mahasiswa/PengajuanKuliahUmum" component={PengajuanKUM} mahasiswa />
      <ProtectedRoute exact path="/Mahasiswa/BuatKlaim" component={BuatKlaimKum} mahasiswa />
      <ProtectedRoute exact path="/Admin/BuatKum" component={BuatKum} admin />
      <ProtectedRoute exact path="/Admin/EditKum/:idKum" component={EditKum} admin />
      <ProtectedRoute exact path="/Admin/HistoriKum" component={HistoriKum} admin />
      <ProtectedRoute exact path="/Superadmin/RegistrasiAdmin" component={TambahAdmin} superadmin />
      <ProtectedRoute exact path="/Mahasiswa/PengajuanKuliahUmum/DaftarProgres" component={DaftarProgres} mahasiswa />
      <ProtectedRoute exact path="/Mahasiswa/PengajuanKuliahUmum/detail/:idProgres" component={DetailProgres} mahasiswa />
      <ProtectedRoute exact path="/Mahasiswa/HistoriPengajuanPartisipasi" component={HistoriPengajuanPartisipasi} mahasiswa />
      <ProtectedRoute exact path="/Mahasiswa/DetailPengajuanPartisipasi/:idKum" component={DetailPengajuanPartisipasi} mahasiswa />
      <ProtectedRoute exact path="/Admin/PemeriksaanMahasiswa" component={PemeriksaanMahasiswa} admin />
      <Route render={() => <Unknown message="No path found" />} />
    </Switch>
  </Router>
);

export default Routes;
